import { render, staticRenderFns } from "./RegisterPartner.vue?vue&type=template&id=4b8779c8"
import script from "./RegisterPartner.vue?vue&type=script&lang=js"
export * from "./RegisterPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports